// Edit product.code order here and redeploy to change desktop pricing display order.
// Products not listed appear after these, sorted alphabetically by code.
export const DESKTOP_PRODUCT_SORT_ORDER: string[] = [
  '105', // Lite Edition
  '190', // AccuMUVXtreme
  '160', // REI (Real Estate)
  '101', // Standard
  '110', // Business
  '106', // Business /w ANK
  '112', // Full Service
  '109', // Professional +
  '103', // Professional

  '102',
  '104',
  '108',
  '109',
  '191',
  '201',
  '202',
  '204',
  '205',
  '206',
  '207',
  '208',
  '209',
  '211',
  '212',
  '213',
  '214',
  '215',
  '230',
  '400',
  '505',
  '506',
  '600',
];

// CASS Certified RESTful API credit products, in display order.
// Matches products.code (type === 'api'). Edit here to add/reorder rows.
export const CASS_API_PRICING_CODES: string[] = [
  '960',
  '961',
  '962',
  '963',
  '964',
  '965',
  '966',
  '967',
  '968',
  '969',
  '969B',
  '970',
  '971',
  '972',
  '973',
  '974',
  '975',
  '976',
  '977',
];

// AccuZIPToolkit API products. Main row prices come from the DB (price), the
// "- Additional Licenses" row from site_price. Evaluation fee is not in the
// pricing response, so it is configured here per code.
export const TOOLKIT_EVALUATION_FEE_BY_CODE: Record<string, string> = {
  '900': '$295.00',
  '901': '$295.00',
  '902': '$295.00',
  '903': '$295.00',
};

// Annual file-retention products share a single code (908), differentiated by
// variance_code. Ordered list drives the retention pricing table rows.
export const DATA_RETENTION_PRODUCT_CODE = '908';
export const DATA_RETENTION_VARIANTS: {
  varianceCode: string;
  label: string;
}[] = [
  { varianceCode: 'XX30', label: '30-Days' },
  { varianceCode: 'XX60', label: '60-Days' },
  { varianceCode: 'XX90', label: '90-Days' },
  { varianceCode: 'X120', label: '120-Days' },
];

// Annual credit volume per CASS API product code. Not stored in the DB, so the
// "Volume" and "$ per unit" (price_12_month / volume) columns are derived here.
export const CASS_API_VOLUME_BY_CODE: Record<string, number> = {
  '960': 10000,
  '961': 50000,
  '962': 75000,
  '963': 100000,
  '964': 150000,
  '965': 250000,
  '966': 300000,
  '967': 360000,
  '968': 500000,
  '969': 1000000,
  '969B': 3000000,
  '970': 5000000,
  '971': 10000000,
  '972': 20000000,
  '973': 50000000,
  '974': 100000000,
  '975': 150000000,
  '976': 200000000,
  '977': 250000000,
};
